import React from "react";
import OrderSummary from "./Components/OrderSummary";
import Statistics from "./Components/Statistics";
import StockUpdate from "./Components/StockUpdate";
import TodayInfo from "./Components/TodayInfo";
import Transactions from "./Components/Transactions";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import Calender from "../../Components/Calender";
export default function General() {
  return (
    <div className="row">
      <LazyLoadComponent>
        <Transactions />
      </LazyLoadComponent>
      <LazyLoadComponent>
        <TodayInfo />
      </LazyLoadComponent>
      <LazyLoadComponent>
        <Statistics />
      </LazyLoadComponent>
      <LazyLoadComponent>
        <div className="col-md-8">
          <OrderSummary />
        </div>
      </LazyLoadComponent>
      <LazyLoadComponent>
        <div className="col-md-4">
          <StockUpdate />
        </div>
      </LazyLoadComponent>
    </div>
  );
}
